import "./js/sticky-hover"
import Home from "./js/home/home"
import Portfolio from "./js/portfolio/portfolio"
import { didScroll } from './js/portfolio/portfolio-item'
import './scss/main.scss'

new Portfolio( document.querySelector( '.portfolio' ) );

const firstThumb = document.querySelector( '.portfolio-item' );

new Home( document.getElementById('home'), firstThumb.dataset.color );

const address = ['info', '@', 'nuthinking', '.', 'com'].join('');
document.querySelector( 'footer .contact .email' ).addEventListener( 'click', (e)=>
{
  e.preventDefault();

  window.location = "mailto:" + address;
});

didScroll(null);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/